(ns frontend.view.grid.surveys-grid.mass-remind.sub
  (:require [common.languages :as languages]
            [common.localization :as loc]
            [common.util :as cu]
            [frontend.view.grid.surveys-grid.mass-remind.model :as model]
            [re-frame.core :as rf]
            [ui.util :as uu]))

(rf/reg-sub
 ::processing?
 (fn [db _]
   (get-in db model/processing?-full-path)))

(rf/reg-sub
 ::loading?
 (fn [db _]
   (get-in db model/loading?-full-path)))

(rf/reg-sub
 ::validation-errors
 :<-
 [::subjects]
 :<-
 [::bodies-1]
 (fn [[subjects bodies-1] _]
   (let [non-blank-subject-langs (->> subjects
                                      (keep (fn [[lang subject]]
                                              (when-not (cu/blank-value? subject)
                                                lang))))
         languages (distinct (into [:ENG] non-blank-subject-langs))]
     (->> languages
          (keep (fn [lang]
                  (cond (cu/blank-value? (get subjects lang))
                        (loc/tr :missing-language-field [(languages/get-label lang) (loc/tr :email/subject)])
                        (cu/blank-value? (get bodies-1 lang))
                        (loc/tr :missing-language-field [(languages/get-label lang) (loc/tr :email-body-part-1)]))))
          (seq)))))

(defn resolve-language-counts
  [processes]
  (->> processes
       (mapcat :survey-process/burned-languages)
       (frequencies)))

(defn resolve-languages
  [processes]
  (->> (concat [:ENG]
               (keys (resolve-language-counts processes)))
       (distinct)
       (vec)))

(rf/reg-sub
 ::processes
 (fn [db _]
   (get-in db model/processes-full-path)))

(rf/reg-sub
 ::language-counts
 :<-
 [::processes]
 (fn [processes _]
   (resolve-language-counts processes)))

(defn process-label
  [lang process]
  (or (get-in process [:survey-process/localized-labels lang])
      (get-in process [:survey-process/localized-labels :ENG])
      (->> process
           :survey-process/localized-labels
           (first)
           (val))))

(rf/reg-sub
 ::selected-lang-processes-data
 :<-
 [::processes]
 :<-
 [::selected-lang]
 (fn [[process selected-lang] _]
   (->> process
        (filter (fn [{:keys [survey-process/burned-languages]}]
                  (some #{selected-lang} burned-languages)))
        (map (fn [sp]
               {"id"       (:db/id sp)
                "target"   (:target sp)
                "label"    (process-label selected-lang sp)
                "invitees" (->> sp
                                :survey-process/invitees
                                (map :email)
                                (uu/list->and-string))}))
        (seq))))

(rf/reg-sub
 ::languages
 :<-
 [::processes]
 (fn [processes _]
   (resolve-languages processes)))

(rf/reg-sub
 ::selected-lang
 (fn [db _]
   (get-in db model/selected-lang-full-path :ENG)))

(rf/reg-sub
 ::subjects
 (fn [db _]
   (get-in db model/subject-full-path)))

(rf/reg-sub
 ::subject
 :<-
 [::subjects]
 :<-
 [::selected-lang]
 (fn [[subjects lang] _]
   (get subjects lang)))

(rf/reg-sub
 ::bodies-1
 (fn [db _]
   (get-in db model/body-1-full-path)))

(rf/reg-sub
 ::body-1
 :<-
 [::bodies-1]
 :<-
 [::selected-lang]
 (fn [[bodies lang] _]
   (get bodies lang)))

(rf/reg-sub
 ::bodies-2
 (fn [db _]
   (get-in db model/body-2-full-path)))

(rf/reg-sub
 ::body-2
 :<-
 [::bodies-2]
 :<-
 [::selected-lang]
 (fn [[bodies lang] _]
   (get bodies lang)))

(rf/reg-sub
 ::modal-open?
 (fn [db _]
   (get-in db model/modal-open?-full-path)))

(rf/reg-sub
 ::results
 (fn [db _]
   (get-in db model/results-full-path)))

(def debug (atom {}))

(rf/reg-sub
 ::results-data
 :<-
 [::results]
 :<-
 [::processes]
 :<-
 [::selected-lang]
 (fn [[results processes selected-lang] _]
   (swap! debug assoc
          :results results
          :processes processes
          :selected-lang selected-lang)
   (->> processes
        (mapcat (fn [sp]
                  (let [process-results (get results (:db/id sp))]
                    (->> sp
                         :survey-process/invitees
                         (map :email)
                         (map (fn [invitee-email]
                                (let [invitee-result (get process-results invitee-email)]
                                  {:process-id    (:db/id sp)
                                   :target-name   (:target sp)
                                   :process-label (process-label selected-lang sp)
                                   :invitee-email invitee-email
                                   :result        invitee-result}))))))))))
